<template>
  <div class="riiqosxn riiqosxn-two">
    <v-container>
      <v-row>
        <v-col cols="12">
          <h1 class="title-lg">Chat & <br>Messages</h1>
          <div class="col-content">
            <h5>CLEAR COMMUNICATION</h5>
            <p>Chat live with website visitors who have been filtered to the preferred departments. Or let them leave a message and contact them later. </p>
            <p>Enjoy improving your lead conversion rates.</p>
            <router-link to="contact" class="btn btn-getstarted">Get Started</router-link>
          </div>
        </v-col>
      </v-row>
      <v-row class="row-img">
        <v-col cols="12" sm="6" class="col-left">
          <div class="img-1"></div>
        </v-col>
        <v-col cols="12" sm="6" class="col-right">
          <div class="col-img"></div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'SxnTwo',

  data: () => ({
    
  }),
};
</script>
